export const version = '2.16.5';
//# sourceMappingURL=version.js.map